export default __webpack_public_path__ + "static/media/E04.6a91d02c.mp3";